import { dispatchCustomEvent } from './helpers/event'

export function registerOutsideClickHandler() {
    const elementsToListenFor = new Set<OutsideClickHandler>()

    class OutsideClickHandler extends HTMLElement {
        public connectedCallback() {
            elementsToListenFor.add(this)
        }
        public disconnectedCallback() {
            elementsToListenFor.delete(this)
        }
    }

    function handleEvent(event: Event) {
        for (const element of elementsToListenFor.values()) {
            if (element.contains(event.target as Node)) continue

            dispatchCustomEvent(element, 'outside-click')
        }
    }

    document.body.addEventListener('mousedown', handleEvent)
    document.body.addEventListener('touchstart', handleEvent)
    customElements.define('zaptic-outside-click-handler', OutsideClickHandler)
}
